import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataServiceService } from '../../services/data-service.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrl: './auth-callback.component.scss'
})
export class AuthCallbackComponent {

  constructor(
    private route: ActivatedRoute,
    private dataServiceService: DataServiceService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private authService: AuthService
  ) {
    // Bypass token processing and redirect directly to main page
    this.router.navigate(['/dispatch_dash'], { replaceUrl: true });
    
    /* Original authentication code
    route.queryParams.subscribe(params => {
      if (params['code']) {
        this.authService.getToken(params['code']).subscribe(() => {
          this.router.navigate(['/dispatch_dash'], { replaceUrl: true });
        });
      }
    });
    */
  }

  ngOnInit() {
  }
}